import { render, staticRenderFns } from "./ChannelPart5.vue?vue&type=template&id=11b419c7&scoped=true&"
import script from "./ChannelPart5.vue?vue&type=script&lang=js&"
export * from "./ChannelPart5.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPart5.vue?vue&type=style&index=0&id=11b419c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b419c7",
  null
  
)

export default component.exports